import * as XLSX from 'xlsx';
import { jwtDecode } from 'jwt-decode';

import dayjs from 'dayjs';
import { DecryptString } from './Encrypt/NtxEncrypt';
// import { store } from '../store/index';
// import axios from 'axios';
// import { variables } from '../API/variables';
// import { DecryptString } from './Encrypt/NtxEncrypt';
// import { setAuthUser } from '../store/Login/loginSlice';

export const isTokenValid = () => {
  const AuthUser = localStorage?.AuthUser ? JSON.parse(DecryptString(localStorage?.AuthUser)) : null;
  const Token = AuthUser?.token;
  // const Token = (store.getState() as any)?.userLogin?.AuthUser?.token;

  if (!Token) return false;

  const user: any = jwtDecode(Token);
  const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;

  if (isExpired) {
    return false;
  } else {
    return true;
  }
};

//________________________________________________________________

export const exportToExcel = (data: unknown[], fileName: unknown) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

//__________________________________________________________

export function getSubdomain() {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  if (import.meta.env.MODE === 'development') {
    return 'NTX';
    // return 'AZZ'; //
  }

  if (parts.length > 2) {
    return parts[0]?.toUpperCase();
  }

  return null;
}

//__________________________________________________________
export const playErrorSound = () => {
  const audioCtx = new (window.AudioContext || window.AudioContext)();
  const oscillator = audioCtx.createOscillator();
  const gainNode = audioCtx.createGain();

  oscillator.type = 'square'; // نوع الصوت
  oscillator.frequency.setValueAtTime(220, audioCtx.currentTime); // تردد منخفض (لا أساسي)
  gainNode.gain.setValueAtTime(1, audioCtx.currentTime); // مستوى الصوت

  oscillator.connect(gainNode);
  gainNode.connect(audioCtx.destination);

  oscillator.start();
  oscillator.stop(audioCtx.currentTime + 0.4); // مدة الصوت: 400 ملي ثانية
};
//__________________________________________________________
